import React, { useState } from 'react'; // 1. Import useState
import { List, Avatar, Button, Space } from 'antd';
import { EyeOutlined, LikeOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const ArticleCardSearchList = ({ articles }) => {
  const navigate = useNavigate();

  // 2. State for current page
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5; // You can adjust this number as needed

  const handleReadMore = (article) => {
    navigate(`/articles/${article.id}`, { state: { article } });
  };

  return (
    <div style={{ padding: 20 }}>
      <List
        itemLayout="horizontal"
        dataSource={articles}
        // 3. Use the built-in pagination prop
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          onChange: (page) => setCurrentPage(page),
          align: 'center', // Centers the pagination buttons
          style: { marginTop: '20px' }
        }}
        renderItem={article => (
          <List.Item
            onClick={() => handleReadMore(article)}
            style={{ cursor: 'pointer', padding: '16px 0' }}
            actions={[
              <Space>
                <EyeOutlined /> {article.views}
              </Space>,
              <Space>
                <LikeOutlined /> {article.likes.length}
              </Space>,
              <Button type="primary" onClick={(e) => { e.stopPropagation(); handleReadMore(article); }}>
                Read More
              </Button>
            ]}
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  shape="square"
                  size={120}
                  src={article.coverUrl || '/default.jpg'}
                  style={{ objectFit: 'cover' }}
                />
              }
              title={
                <div style={{ fontWeight: 700, fontSize: 16 }}>
                  {article.title}
                </div>
              }
              description={
                <div>
                  <div style={{ color: '#555', margin: '4px 0' }}>
                    {article?.SubCategory?.name || (article.description ? article.description.slice(0, 100) + '...' : '')}
                  </div>
                  <div style={{ color: '#888', fontSize: 13, fontWeight: 500 }}>
                    Author: {article?.User?.name ?? 'Unknown'}
                  </div>
                  <div style={{ color: '#888', fontSize: 12 }}>
                    Published {moment(article.createdAt).format('LL')}
                  </div>
                </div>
              }
            />
          </List.Item>
        )}
        split
      />
    </div>
  );
};

export default ArticleCardSearchList;